import "zod/compile";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./global.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { AuthRoot } from "./routes/RootPage/AuthRoot";
import { RouterWrapper } from "./routes/RouterWrapper";

ReactDOM.createRoot(
  document.getElementById("te-registration") as HTMLElement
).render(
  // StrictMode renders components twice (on dev but not production)
  // in order to detect any problems with your code and warn you about them
  // making useEffect trigger twice

  <StrictMode>
    <Provider store={store}>
      <AuthRoot>
        <RouterWrapper />
      </AuthRoot>
    </Provider>
  </StrictMode>
);
